import { GoalFeedbackPost } from "../../post.models";
import "./goal_feedback.component.css";

export interface GoalFeedbackProps extends GoalFeedbackPost {}

export function GoalFeedbackPostBody(props: GoalFeedbackProps) {
  return (
    <div
      id={`${props.id}-container`}
      className={"goal_feedback-view-container"}
      style={{ maxHeight: props.height, whiteSpace: "pre-wrap" }}
    >
      {props.goals}
    </div>
  );
}
